export default "__VITE_ASSET__v_XBld9q__"